// import React from "react";
// import "./Solucoes.css";
// import { Compass, Target, Users, TrendingUp } from "lucide-react";

// const Solucoes = () => {
//   const services = [
//     {
//       icon: Compass,
//       title: "Posicionamento",
//       description:
//         "Definição clara do posicionamento da sua clínica no mercado, diferenciação competitiva e proposta de valor única.",
//       features: [
//         "Análise de mercado",
//         "Definição de persona",
//         "Proposta de valor",
//         "Branding médico",
//       ],
//     },
//     {
//       icon: Target,
//       title: "Estratégia",
//       description:
//         "Desenvolvimento de estratégias de crescimento sustentável com foco em resultados mensuráveis e escalabilidade.",
//       features: [
//         "Planejamento estratégico",
//         "Definição de metas",
//         "Roadmap de crescimento",
//         "KPIs personalizados",
//       ],
//     },
//     {
//       icon: Users,
//       title: "Comercial",
//       description:
//         "Otimização de processos comerciais, desde a captação até a retenção de pacientes e maximização do ticket médio.",
//       features: [
//         "Funil de vendas",
//         "CRM médico",
//         "Retenção de pacientes",
//         "Upsell e cross-sell",
//       ],
//     },
//     {
//       icon: TrendingUp,
//       title: "Cultura",
//       description:
//         "Desenvolvimento de cultura organizacional forte, engajamento de equipe e processos de excelência operacional.",
//       features: [
//         "Cultura organizacional",
//         "Treinamento de equipe",
//         "Processos internos",
//         "Gestão de performance",
//       ],
//     },
//   ];

//   return (
//     <section id="atuacao" className="solucoes-section" data-aos="fade-in">
//       <div className="solucoes-container">
//         <div className="solucoes-header">
//           <span className="cases-label">Áreas de Atuação</span>
//           <h2 className="solucoes-title">
//             Soluções completas para{" "}
//             <span className="highlight">sua clínica</span>
//           </h2>
//           <p className="solucoes-subtitle">
//             Oferecemos consultoria estratégica em quatro pilares fundamentais
//             para transformar sua clínica em um negócio de alto valor e
//             performance.
//           </p>
//         </div>

//         <div className="solucoes-grid">
//           {services.map((service, index) => (
//             <div key={index} className="solucoes-card">
//               <div className="solucoes-card-content">
//                 <div className="solucoes-icon-title">
//                   <div className="solucoes-icon-wrapper">
//                     <service.icon className="solucoes-icon" />
//                   </div>
//                   <h3 className="solucoes-card-title">{service.title}</h3>
//                 </div>

//                 <p className="solucoes-description">{service.description}</p>

//                 <div className="solucoes-features">
//                   <h4 className="solucoes-feature-title">O que incluímos:</h4>
//                   <div className="solucoes-feature-list">
//                     {service.features.map((feature, idx) => (
//                       <div key={idx} className="solucoes-feature-item">
//                         <div className="solucoes-bullet"></div>
//                         <span>{feature}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <div className="solucoes-cta">
//                   <button className="saiba-mais">Saiba mais →</button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="solucoes-bottom-cta">
//           <button className="btn-primary">
//             Descobrir Qual Solução é Ideal para Mim
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Solucoes;

import React from "react";
import "./Solucoes.css";
import { CheckCircle } from "lucide-react";

const Solucoes = () => {
  const publicoAlvo = [
    "Quem já tentou com outras agências, mas não encontrou método nem resultado consistente",
    "Consultórios com boa demanda, mas que não têm previsibilidade de crescimento",
    "Equipes que precisam de método, clareza e alinhamento",
    "Quem já fatura alto e quer escalar com estrutura",
    "Quem está começando e quer fazer certo desde o início",
    "Dentistas e médicos que querem sair da estagnação",
  ];

  return (
    <section id="atuacao" className="solucoes-section" data-aos="fade-in">
      <div className="solucoes-container">
        <div className="solucoes-header">
          <span className="cases-label">Quem Atendemos</span>
          <h2 className="solucoes-title">
            Pra quem é o <span className="highlight">Projeto Arcadian?</span>
          </h2>
          <p className="solucoes-subtitle">
            Nosso projeto foi desenhado para clínicas e consultórios que buscam
            performance, método e crescimento previsível.
          </p>
        </div>

        <div className="solucoes-grid">
          {publicoAlvo.map((item, index) => (
            <div key={index} className="solucoes-card">
              <div className="solucoes-card-content">
                <div className="solucoes-icon-title">
                  <div className="solucoes-icon-wrapper">
                    <CheckCircle className="solucoes-icon" />
                  </div>
                  <h3 className="solucoes-card-title">{item}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="solucoes-bottom-cta">
          <button className="btn-primary">
            Quero Avaliar se a Arcadian é pra Mim
          </button>
        </div>
      </div>
    </section>
  );
};

export default Solucoes;
